import { render } from "./NoMaterialsRequired.vue?vue&type=template&id=3f4094bf&scoped=true"
import script from "./NoMaterialsRequired.vue?vue&type=script&lang=js"
export * from "./NoMaterialsRequired.vue?vue&type=script&lang=js"

import "./NoMaterialsRequired.vue?vue&type=style&index=0&id=3f4094bf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4094bf"]])

export default __exports__